import React, { useState,useEffect }  from 'react'
import {Grid, AppBar, Container, Stack, IconButton, FormLabel, RadioGroup, Alert, CircularProgress, Modal, Box, Typography, Button} from '@mui/material'
import WbButton from '../../components/common/WbButton'
import WbTextField from '../../components/common/WbTextField'
import WbRadioButton from '../../components/common/WbRadioButton'
import { imghello } from '../../components/assets/images'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { angryEmoji, annoyedEmoji, calmEmoji, confusedEmoji, excitedEmoji, focusedEmoji, happyEmoji, hurtEmoji, ragingEmoji, sadEmoji, sickEmoji, sillyEmoji, surprisedEmoji, terrifiedEmoji, tiredEmoji, worriedEmoji } from '../../components/assets/images'
import { useNavigate  } from 'react-router-dom';
import paths from '../../routes/paths'
import unifiedLogout from '../../utils/unifiedLogout'
import { safeSpaceApi } from '../../services/api/safespace/safeSpaceApi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function NewConversation() {
  // Helper to check if current time is within out-of-hours
  function isWithinOutOfHours() {
    if (!isoutOfHoursEnabled || !outOfHoursStartTime || !outOfHoursEndTime) return false;
    const now = new Date();
    const [startHour, startMinute] = outOfHoursStartTime.split(':').map(Number);
    const [endHour, endMinute] = outOfHoursEndTime.split(':').map(Number);
    const start = new Date(now);
    start.setHours(startHour, startMinute, 0, 0);
    const end = new Date(now);
    end.setHours(endHour, endMinute, 0, 0);
    if (end < start) {
      // Overnight range
      if (now >= start) return true;
      if (now <= end) return true;
      return false;
    }
    return now >= start && now <= end;
  }
  const navigate = useNavigate(); 

  // Read from localStorage and get message type 3 (IsAnnonymous)
  const safeSpaceConfig = JSON.parse(localStorage.getItem('safeSpaceConfig'));
  const anonymousMessage = safeSpaceConfig?.messages?.find(msg => msg.messageType === 3);
  const anonymousoutOfHoursMessage = safeSpaceConfig?.messages?.find(msg => msg.messageType === 1);


  const [formData, setFormData] = useState({
    subject: '',
    message: '',
    selectedZone: '',
    responsePreference: safeSpaceConfig.allowMessageResponse ? '2' : (safeSpaceConfig.allowInPersonResponse ? '1' : ''),    
    attachedFile: null,
    isAnonymous: '1',// anonymousMessage?.isEnabled ? '2' : '1', // Set to No if enabled, Yes if not     
  });
  const [loading, setLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const pupilData = JSON.parse(localStorage.getItem('pupil') || '{}');
  const staffData = JSON.parse(localStorage.getItem('selectedStaff') || '{}');   
  const [openModal, setOpenModal] = useState(false);

    // Get specific properties with null checks
    const anonymousMessageContent = anonymousMessage?.messageContent;
    const isAnonymousEnabled = anonymousMessage?.isEnabled;
    const isZoneOfRegulationEnabled = safeSpaceConfig?.isZoneOfRegulationEnabled;
    const anonymousoutOfHoursMessageContent = anonymousoutOfHoursMessage?.messageContent;
    const isoutOfHoursEnabled = anonymousoutOfHoursMessage?.isEnabled;
    const outOfHoursStartTime = anonymousoutOfHoursMessage?.outOfHoursStartTime;
    const outOfHoursEndTime = anonymousoutOfHoursMessage?.outOfHoursEndTime;
    
    // Auto response message content
    const autoResponceMessage = safeSpaceConfig?.messages?.find(msg => msg.messageType === 0);
    const autoResponceMessageContent = autoResponceMessage?.messageContent;
   
     // Set default selectedZone to 'BLUE' if zones are disabled
    useEffect(() => {
      if (isZoneOfRegulationEnabled === false && formData.selectedZone !== 'BLUE') {
        setFormData(prev => ({ ...prev, selectedZone: 'BLUE' }));
      }
    }, [isZoneOfRegulationEnabled]);
    
    // Example usage:
    if (anonymousMessage && anonymousMessage.isEnabled) {
        console.log('Anonymous Message:', anonymousMessage.messageContent);
    }


    useEffect(() => {
    if (formData.responsePreference === '1' && formData.isAnonymous !== '1') {
      setFormData(prev => ({
        ...prev,
        isAnonymous: '1'
      }));
    }
  }, [formData.responsePreference]);
  // Add modal style
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };
 
const handleInputChange = (field, value) => {
  if (field === 'responsePreference') {
    if (value === '1') {
      //setOpenModal(true);
       setFormData(prev => ({
        ...prev,
        responsePreference: '1',  // Set to in-person
        isAnonymous: '1'  // Set to not anonymous (Yes)
      }));
    } else if (value === '2') {
      setFormData(prev => ({
        ...prev,
        responsePreference: value,
        isAnonymous: '2' // Set to No (anonymous)
      }));
    }
  } else {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};

const handleModalConfirm = () => {
  setFormData(prev => ({
    ...prev,
    responsePreference: '1',  // Set to in-person
    isAnonymous: '1'  // Set to not anonymous (Yes)
  }));
  setOpenModal(false);
};

const handleModalCancel = () => {
  setFormData(prev => ({
    ...prev,
    responsePreference: '2',  // Reset to message option
    isAnonymous: '2'  // Reset to anonymous (No)
  }));
  setOpenModal(false);
};


  const handleSubmit = async () => {
    // Validation for subject and message
  if (!formData.subject.trim()) {
    toast.error('Please enter a topic you want to talk about.', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    return;
  }
  if (!formData.message.trim()) {
    toast.error('Please enter your message to tell some more.', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    return;
  }
    // Validation for zone selection
  if (!formData.selectedZone) {
    toast.error('Please select a zone.', {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    return;
  }
    try {
        //debugger;
      setLoading(true);
      
      // Get current date in ISO format
      const currentDate = new Date().toISOString();
      const conversationData = {
        studentId: pupilData.studentId,
        SchoolId: pupilData.schoolId,
        responderId: staffData.responderId,
        conversationTitle: formData.subject,
        conversationStartMessage: formData.message,
        zone: formData.selectedZone,
        hearBackType: formData.responsePreference === '1' ? 'TALK' : 'MESSAGE',
        isNameAnonymous: formData.isAnonymous === '2',
        isSafeGuarded: false,
        isEscalated: false,
        escalatedToStaffId: '',
        isTransfered: false,
        transferedToStaffId: 0,
        sevirity: '',
        conversationTypeId: 0,
        isFollowUpInPerson: false,
        conversationStartDate: currentDate,
        conversationEndDate: currentDate,
        conversationModifiedDate: currentDate,
        isConversationClosed: false,
        isConversationArchived: false
        //attachments: formData.attachedFile ? [formData.attachedFile] : []
      };

      // The request goes first.
      //
      // The success toast and the popup used to fire before it was even sent, and the
      // loader was switched off with them - so a child was told their message had been
      // recorded while it was still in flight, and told the same thing if it failed.
      // On a safeguarding tool that is the worst thing this screen can do.
      const response = await safeSpaceApi.submitSafeSpaceConversation({
        conversation: conversationData
      });

      setLoading(false);
      toast.success('Conversation started successfully!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      setShowSuccessPopup(true);                          
      
          
    } catch (error) {
      setLoading(false);
        toast.error('Failed to submit conversation', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
      console.error('Failed to submit conversation:', error);
    }
  };

  return (
    <>
      <AppBar className="header">
      <ToastContainer />
        <Container maxWidth="xxl">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <div className="logo">
              <span>Welbee</span>
            </div>
            <div>
              <nav>
                <WbButton
                  onClick={() => {
                    unifiedLogout()
                  }}
                  CustomButtonText="Logout"
                />                  
              </nav>
            </div>
          </Stack>
        </Container>
      </AppBar>
      <div className="main-container" style={{position: 'relative'}}>
        {/* Floating Out-of-Hours Message */}
        {isoutOfHoursEnabled && isWithinOutOfHours() && (
          <div style={{
            position: 'fixed',
            top: 100,
            right: 20,
            zIndex: 9999,
            background: '#fff3cd',
            color: '#856404',
            border: '1px solid #ffeeba',
            borderRadius: 8,
            padding: '16px 24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
            minWidth: 320,
            maxWidth: 400
          }}>
            <div style={{fontWeight: 600, marginBottom: 4}}>Out of Hours</div>
            <div>{
              anonymousoutOfHoursMessageContent
                ? anonymousoutOfHoursMessageContent
                    .replace(/\[Adult Name\]/gi, staffData.staffName || '')
                    .replace(/\[From\]/gi, outOfHoursStartTime || '')
                    .replace(/\[To\]/gi, outOfHoursEndTime || '')
                : ''
            }</div>
            {/* <div style={{marginTop: 8, fontSize: 13, color: '#856404'}}>
              From {outOfHoursStartTime} to {outOfHoursEndTime}
            </div> */}
          </div>
        )}
      {loading===true? (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '500px' }}>            
              <CircularProgress />
              <div style={{ marginTop: '16px', color: '#555', fontSize: '16px' }}>Starting new conversation....</div>
            </div>  
            ) : (  
              <>
              <Container maxWidth="lg">              
                    <Grid container mt={4}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <h1>New Conversation</h1>               
                        </Grid>                
                    </Grid>               
                    <Grid container mt={6}>
                        <Grid item lg={12} md={12} sm={12} xs={12} textAlign="center">
                            <h1 className='select-staff-heading'>Send a message to {staffData.staffName}</h1>               
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                            <div className="new-conversation">
                                <Grid container rowGap={3}>
                                    <Grid item lg={7} md={7} sm={12} xs={12}>
                                        <FormLabel className='form-label'>In a few words, what do you want to talk to {staffData.staffName} about?</FormLabel>
                                        <WbTextField
                                            placeholder={'What do you want to talk about'}
                                            value={formData.subject}
                                            onChange={(e) => handleInputChange('subject', e.target.value)}
                                            />
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={3}>
                                        <FormLabel className='form-label'>Your Message</FormLabel>
                                        <WbTextField
                                            className="message-textarea"
                                            multiline
                                            rows={4}
                                            value={formData.message}
                                            onChange={(e) => handleInputChange('message', e.target.value)}
                                            placeholder={`Tell ${staffData.staffName} more...`}
                                        />
                                    </Grid>

                                    {/* <Grid item lg={12} md={12} sm={12} xs={12} mt={3}>
                                      <Link href="#" underline="hover" className="file-upload-link">
                                        <AttachFileIcon /><span>Upload File</span>                               
                                      </Link>                                  
                                      <div className="file-label">e.g: photos, document or screenshot</div>
                                    </Grid> */}

                                    {/* Zones */}
                                    {isZoneOfRegulationEnabled && (
                                      <Grid item lg={9} md={9} sm={12} xs={12} mt={3}>
                                        <FormLabel className='form-label'>What zone are you in?</FormLabel>
                                        <div className="conversation-zones">
                                          <Grid container columnSpacing={3} mt={3}>
                                            <Grid item lg={3} md={4} sm={6} xs={12}>
                                                <div className='blue-zone zones' 
                                                onClick={() => handleInputChange('selectedZone', 'BLUE')}
                                                style={{ opacity: formData.selectedZone && formData.selectedZone !== 'BLUE' ? 0.5 : 1 }}>
                                                    <div className={`blue-emojis zone ${formData.selectedZone === 'BLUE' ? 'selected' : ''}`}>
                                                        <div className="emojis">
                                                            <img src={sadEmoji} alt="" />
                                                            <span>Sad</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={hurtEmoji} alt="" />
                                                            <span>Hurt</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={sickEmoji} alt="" />
                                                            <span>Sick</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={tiredEmoji} alt="" />
                                                            <span>Tired</span>
                                                        </div>
                                                    </div>
                                                    <h2>Blue Zone</h2>
                                                </div>
                                            </Grid>
                                            <Grid item lg={3} md={4} sm={6} xs={12}>
                                                <div className='zones green-zone'
                                                 onClick={() => handleInputChange('selectedZone', 'GREEN')}
                                                 style={{ opacity: formData.selectedZone && formData.selectedZone !== 'GREEN' ? 0.5 : 1 }}>
                                                    <div className={`green-emojis zone ${formData.selectedZone === 'GREEN' ? 'selected' : ''}`}>
                                                        <div className="emojis">
                                                            <img src={happyEmoji} alt="" />
                                                            <span>Happy</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={focusedEmoji} alt="" />
                                                            <span>Focused</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={calmEmoji} alt="" />
                                                            <span>Calm</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={excitedEmoji} alt="" />
                                                            <span>Excited</span>
                                                        </div>
                                                    </div>
                                                    <h2>Green Zone</h2>
                                                </div>
                                            </Grid>
                                            <Grid item lg={3} md={4} sm={6} xs={12}>
                                            <div className='zones orange-zone'
                                                onClick={() => handleInputChange('selectedZone', 'ORANGE')}
                                                style={{ opacity: formData.selectedZone && formData.selectedZone !== 'ORANGE' ? 0.5 : 1 }}>
                                                <div className={`orange-emojis zone ${formData.selectedZone === 'ORANGE' ? 'selected' : ''}`}>
                                                        <div className="emojis">
                                                            <img src={surprisedEmoji} alt="" />
                                                            <span>Surprised</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={confusedEmoji} alt="" />
                                                            <span>Confuse</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={worriedEmoji} alt="" />
                                                            <span>Worried</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={sillyEmoji} alt="" />
                                                            <span>Silly</span>
                                                        </div>
                                                    </div>
                                                    <h2>Orange Zone</h2>                                        
                                                </div>
                                            </Grid>
                                            <Grid item lg={3} md={4} sm={6} xs={12}>
                                            <div className='zones red-zone'
                                                onClick={() => handleInputChange('selectedZone', 'RED')}
                                                style={{ opacity: formData.selectedZone && formData.selectedZone !== 'RED' ? 0.5 : 1 }}>
                                                <div className={`red-emojis zone ${formData.selectedZone === 'RED' ? 'selected' : ''}`}>
                                                        <div className="emojis">
                                                            <img src={angryEmoji} alt="" />
                                                            <span>Angry</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={ragingEmoji} alt="" />
                                                            <span>Raging</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={terrifiedEmoji} alt="" />
                                                            <span>Terrified</span>
                                                        </div>
                                                        <div className="emojis">
                                                            <img src={annoyedEmoji} alt="" />
                                                            <span>Annoyed</span>
                                                        </div>
                                                    </div>
                                                    <h2>Red Zone</h2>
                                                </div>
                                            </Grid>
                                          </Grid>
                                        </div>
                                      </Grid>
                                    )}

                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={3}>
                                        <FormLabel className='form-label'>How do you want to hear back from {staffData.staffName}?</FormLabel>
                                        <RadioGroup className="radio-group"
                                          value={formData.responsePreference}
                                          onChange={(e) => handleInputChange('responsePreference', e.target.value)}
                                        >
                                            {safeSpaceConfig.allowInPersonResponse && (
                                              <WbRadioButton
                                                value={1}
                                                label={'I want them to come and talk to me'}
                                              />
                                            )}
                                              {formData.responsePreference === '1' && safeSpaceConfig.allowInPersonResponse && (
                                              <Grid container>
                                                <Grid item lg={6} md={7} sm={12} xs={12}>
                                                  <Typography
                                                    variant="body2"
                                                    sx={{
                                                      my: 1,
                                                      p: 2,
                                                      bgcolor: '#E3F2FD',
                                                      color: '#1565C0',
                                                      borderRadius: 1,
                                                      border: '1px solid #90CAF9',
                                                      fontSize: '17px',
                                                    }}
                                                  >
                                                    {staffData.staffName} or another trusted adult will come to see you.
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            )}
                                            {safeSpaceConfig.allowMessageResponse && (
                                              <WbRadioButton
                                                value={2}
                                                label={'I want them to message me here'}
                                              />
                                            )}
                                        </RadioGroup>
                                    </Grid>

                                    <Grid item lg={6} md={7} sm={12} xs={12} mt={3}>                                                                            
                                      {anonymousMessage && anonymousMessage.isEnabled && formData.responsePreference !== '1'? (
                                         <>
                                         <FormLabel className='form-label'>Do you want {staffData.staffName} to know your name?</FormLabel>
                                          <RadioGroup 
                                              className="radio-group"
                                              value={formData.isAnonymous}
                                              onChange={(e) => handleInputChange('isAnonymous', e.target.value)}
                                          >
                                              <WbRadioButton 
                                                  value="1"
                                                  label="Yes"
                                                  disabled={formData.responsePreference === '1'}
                                              />
                                              <WbRadioButton 
                                                  value="2"
                                                  label="No"
                                                  disabled={formData.responsePreference === '1'}
                                              />
                                          </RadioGroup>
                                          {formData.isAnonymous === '2' && anonymousMessageContent && (
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    mt: 1,
                                                    p: 2,
                                                    bgcolor: '#FFF3CD',
                                                    color: '#856404',
                                                    borderRadius: 1,
                                                    border: '1px solid #FFEEBA',
                                                    fontSize: '17px',
                                                }}
                                            >
                                                {anonymousMessageContent.replace(/\[Adult Name\]/gi, staffData.staffName || '')}
                                            </Typography>
                                          )}                                         
                                        </>
                                      ) : (   
                                         <Typography
                                                variant="body2"
                                                sx={{                                                    
                                                    p: 2,
                                                    bgcolor: '#FFF3CD',
                                                    color: '#856404',
                                                    borderRadius: 1,
                                                    border: '1px solid #FFEEBA',
                                                    fontSize: '17px',
                                                }}
                                            >
                                                * Your name will be visible for in-person communication
                                            </Typography>                                        
                                      )}                                                                           
                                  </Grid>

                                    <Grid item lg={12} md={12} sm={12} xs={12} mb={8} mt={2}>
                                      <WbButton                                
                                        className="start-conv-button"
                                        CustomButtonText={'Start Conversation'} 
                                        // onClick={e => navigate(paths.startConversation)}  
                                        onClick={handleSubmit} 
                                      />                             
                                    </Grid>

                                </Grid>
                            </div>                                                                          
                        </Grid>
                    </Grid>                        
              </Container>
              <div className='new-conversation-image'>
                  <img src={imghello} alt="hello" />
              </div>
              </>
           )}  
      </div>

      <Modal
        open={openModal}
        onClose={handleModalCancel}
        aria-labelledby="confirm-modal"
        aria-describedby="confirm-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h1">
            <b>Confirmation Message</b>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 3 }}>
            <b>{staffData.staffName}</b> will reply you within 2 working days.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <WbButton
              CustomButtonText="Cancel"
              onClick={handleModalCancel}
              sx={{ backgroundColor: '#grey' }}
            />
            <WbButton
              CustomButtonText="OK"
              onClick={handleModalConfirm}
            />
          </Box>
        </Box>
      </Modal>

      {/* Success Popup Modal */}
      <Modal
        open={showSuccessPopup}
        aria-labelledby="success-modal"
        aria-describedby="conversation-success"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.9)'
        }}
      >
        <Box
          sx={{
            p: 4,
            bgcolor: 'background.paper',
            borderRadius: 3,
            boxShadow: 3,
            textAlign: 'left',
            width: '100%',
            maxWidth: 600,
            m: 2
          }}
        >
          <Typography variant="h4" gutterBottom>
            Message Sent!
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            {autoResponceMessageContent && autoResponceMessageContent.trim() !== ''
              ? autoResponceMessageContent.replace(/\[Adult Name\]/gi, staffData?.staffName || '')
              : `${staffData?.staffName || ''} has been sent your message and will get back to you soon.`}
          </Typography>
          <Stack direction="row" justifyContent="center">
            <WbButton
              CustomButtonText="Home"
              onClick={() => {
                setShowSuccessPopup(false);
                navigate(paths.pupilSurveys);
              }}
            />
          </Stack>
        </Box>
      </Modal>
    </>     
  )
}
